import React from 'react';
import styled from 'styled-components';
import { splitLinks } from '../../../../utils/linkify';


const Link = styled.a`
  color: ${(props) => props.theme.colors.Cobalt};
  overflow-wrap: anywhere;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

// Renders text with http(s)/www. URLs as links that open in a new tab. Clicks don't bubble, so links work
// inside clickable cards.
export default function Linkified({ text }: { text: string }): React.ReactElement {
  return (
    <>
      {splitLinks(text).map((part, index) => (part.href
        ? <Link key={index} href={part.href} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>{part.text}</Link>
        : <React.Fragment key={index}>{part.text}</React.Fragment>))}
    </>
  );
}
